import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/laboratoriji";

const initialState = {
  laboratorijDtoList: [],
  isLoading: false,
  error: null,
};

export const fetchLaboratoryCodeList = createAsyncThunk(
  "laboratoryCodeLists/fetchAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const laboratoryCodeListSlice = createSlice({
  name: "laboratoryCodeLists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLaboratoryCodeList.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchLaboratoryCodeList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.laboratorijDtoList = action.payload;
    });
    builder.addCase(fetchLaboratoryCodeList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default laboratoryCodeListSlice.reducer;
